var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.objetoEhVazio(_vm.tipoAtivo)
    ? _c("v-container", { staticClass: "container", attrs: { fluid: "" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.ativoExistenteOuNovo,
                expression: "ativoExistenteOuNovo"
              }
            ]
          },
          [
            _c(_vm.currentForm, {
              tag: "component",
              attrs: {
                formTitle: _vm.formTitle,
                formType: _vm.formType,
                closing: _vm.closing,
                respGetAtiTipUserId_prop: _vm.respGetAtiTipUserId
              },
              on: { save: _vm.save, "buy:activeId": _vm.purchaseChange }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.ativoExistenteOuNovo,
                expression: "!ativoExistenteOuNovo"
              }
            ]
          },
          [
            _c(
              "div",
              { staticClass: "mock" },
              [
                _c(
                  "v-row",
                  { staticClass: "d-flex flex-wrap pb-16 row" },
                  [
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Nome do Ativo")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          [
                            _c("v-select", {
                              staticClass: "select",
                              attrs: {
                                loading: _vm.loading,
                                items: _vm.ativos,
                                attach: "",
                                "menu-props": { bottom: true, offsetY: true },
                                placeholder: "Selecione",
                                color: "secondary",
                                "return-object": true,
                                required: "",
                                counter: "",
                                dense: "",
                                outlined: "",
                                rounded: "",
                                disabled: _vm.loading
                              },
                              on: { change: _vm.changeActive },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          _vm._s(data.item.$index$) +
                                            " - " +
                                            _vm._s(data.item.code)
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          _vm._s(data.item.$index$) +
                                            " - " +
                                            _vm._s(data.item.code)
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                527026556
                              ),
                              model: {
                                value: _vm.ativo,
                                callback: function($$v) {
                                  _vm.ativo = $$v
                                },
                                expression: "ativo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-row", { staticClass: "d-flex flex-wrap pb-16 row" }, [
                      _c(
                        "div",
                        { staticClass: "bloco" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Estratégia")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "column", attrs: { cols: "1" } },
                            [
                              _c("span", { staticClass: "btn" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.estrategia ? _vm.estrategia : ""
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.typeId !== 6 &&
                      _vm.typeId !== 5 &&
                      _vm.typeId !== 7 &&
                      _vm.typeId !== 8
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Indice referência")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.indice ? _vm.indice : "") +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.typeId !== 6 && _vm.typeId !== 7 && _vm.typeId !== 8
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Indexador")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      _vm._s(_vm.indexador ? _vm.indexador : "")
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "bloco" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("FGC")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "column", attrs: { cols: "1" } },
                            [
                              _c("span", { staticClass: "btn" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.fgc ? _vm.fgc : "") + " "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "bloco" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Data Aplicação Inicial")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "column", attrs: { cols: "1" } },
                            [
                              _c("span", { staticClass: "btn" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateHelper.displayValue(
                                      _vm.viewModel.purchaseDate
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.viewModel.expiration != undefined
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Data Vencimento")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateHelper.displayValue(
                                          _vm.viewModel.expiration
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "bloco" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Data ")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "column", attrs: { cols: "1" } },
                            [
                              _c("DatePiker", {
                                attrs: { value: _vm.viewModel.investmentDate },
                                on: {
                                  change: _vm.saveVencimento,
                                  "edit:enter": _vm.emitEnter,
                                  "edit:leave": _vm.emitLeave
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "bloco" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Saldo Líquido ($) ")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "column", attrs: { cols: "1" } },
                            [
                              _c("span", { staticClass: "btn" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.viewModel.netAmount
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.typeId !== 1 && _vm.typeId !== 4
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Quantidade disponível ")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.percentageHelper.formatQuota(
                                          _vm.viewModel.availableUnits
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.closing && (_vm.typeId === 1 || _vm.typeId === 4)
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Valor(R$) ")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("ValorMonetario", {
                                    attrs: {
                                      valor: _vm.viewModel.investedValue
                                    },
                                    on: { change: _vm.saveValorAplicacao }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      [1, 4].indexOf(_vm.typeId) < 0 ||
                      (!_vm.closing && _vm.typeId === 5)
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _vm.typeId === 6
                                    ? _c(
                                        "span",
                                        { staticClass: "text-filelds" },
                                        [_vm._v("Valor da Ação (R$)")]
                                      )
                                    : _vm._e(),
                                  _vm.typeId === 7 || _vm.typeId === 8
                                    ? _c(
                                        "span",
                                        { staticClass: "text-filelds" },
                                        [_vm._v("Valor da Cota (R$)")]
                                      )
                                    : _vm._e(),
                                  _vm.typeId !== 6 &&
                                  _vm.typeId !== 7 &&
                                  _vm.typeId !== 8
                                    ? _c(
                                        "span",
                                        { staticClass: "text-filelds" },
                                        [_vm._v("P. U. da aplicação")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm.typeId !== 8
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "column",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("ValorMonetario", {
                                        attrs: {
                                          value: _vm.viewModel.ppUnit,
                                          disabled: _vm.updatingData
                                        },
                                        on: { change: _vm.saveShareValue }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.typeId === 8
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "column",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("span", { staticClass: "btn" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.viewModel.ppUnit
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      ([1, 4, 5].indexOf(_vm.typeId) < 0 &&
                        [7].indexOf(_vm.typeId) >= 0 &&
                        !_vm.closing) ||
                      (!_vm.closing && _vm.typeId === 5)
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Quantidade")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("ValorMonetario", {
                                    attrs: {
                                      value: _vm.viewModel.units,
                                      disabled: _vm.updatingData
                                    },
                                    on: { change: _vm.saveShareQuantity }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.closing && _vm.typeId !== 1 && _vm.typeId !== 4
                        ? _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Total à retirar (R$)")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("ValorMonetario", {
                                    attrs: {
                                      value: _vm.viewModel.vTotal,
                                      disabled: _vm.updatingData
                                    },
                                    on: { change: _vm.saveInvestedValue }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }